import { SelectionField } from "../../../CommonElements";
import {
  getName,
  getRole,
  getUnitKerjaStorage,
} from "../../../Utils/externalFunctions";
import LIST_UNIT from "../constants/ListUnit";

const SelectionFieldAssessedUnitKerja = ({ updateAssessedBy }) => {
  return getRole() === "Admin" ? (
    <SelectionField
      className={"m-0 py-0 w-75"}
      options={LIST_UNIT.map((unit) => ({ id: unit, name: unit }))}
      placeholder={"Pilih Unit Kerja"}
      onChange={(e) => updateAssessedBy(e.target.value)}
    />
  ) : (
    <SelectionField
      className={"m-0 py-0 w-75"}
      options={[
        { id: getUnitKerjaStorage(), name: getUnitKerjaStorage() },
        getName() === "Dr. Dina Chahyati" && {
          id: "Perpustakaan",
          name: "Perpustakaan",
        },
      ]}
      disabled={getName() !== "Dr. Dina Chahyati"}
      defaultValue={getUnitKerjaStorage()}
      onChange={(e) => updateAssessedBy(e.target.value)}
    />
  );
};

export default SelectionFieldAssessedUnitKerja;
